export interface ItineraryData {
  transportTypes: string[];
  isMultiDestination: boolean;
  isRoundTrip: boolean;
}
export interface EqualProminenceInResultsMobileProps {
  onContinueWithFlight: () => void;
  itineraryData: ItineraryData;
  loading: boolean;
  pricePerPassenger: {
    amount: number;
    currency: string;
  };
  nonDiscountedPricePerPassenger: {
    amount: number;
    currency: string;
  };
  isFlightSummary?: boolean;
  trackedPrice?: {
    amount: number;
    currency: string;
  };
  site?: string;
  abs?: Array<{ alias: string; partition: number }>;
  mocks?: object;
}

export enum FeeTypeId {
  MEMBER_PRICE_POLICY_UNDISCOUNTED = "MEMBER_PRICE_POLICY_UNDISCOUNTED",
  MEMBER_PRICE_POLICY_DISCOUNTED = "MEMBER_PRICE_POLICY_DISCOUNTED",
}
